export default "__VITE_ASSET__C8g10jZj__"